import { useEffect, useState } from "react";
import ButtonComponent from "../shared/button/button.component";
import { ChannelUserService } from "../../services/ChannelUserService";
import { CardBlueIcon, DateTimePickerBlueIcon, DisclaimerBlueIcon, PaymentFailureIcon, PlanFeatureTickIcon, SuccessIcon, UsersPrimaryDarkIcon } from "../../icon";
import { ChannelPlanModel, ChannelPlanStatus, mapToPlanModel, ValidityType } from "../../models/users.model";
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { buttonLabels, pageTitles } from "../shared/constants";
import { Dialog, DialogContent, Grid, LinearProgress } from "@mui/material";
import ChannelSelectPlanComponent from "./select-plan.component";
import { useLocation, useNavigate } from "react-router";
import { AppRoutes } from "../routes/route.path";
import AvatarLoaderComponent from "../shared/loaders/animate-loader.component";
import PlanLoader from "../shared/loaders/plan-loader.json";
import { useDispatch, useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { LoadChannelPlans } from "../../actions";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";

const ChannelPlans = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [changePlan, setChangePlan] = useState<boolean>(false)
    const [loadingPlan, setLoadingPlan] = useState<boolean>(false);

    const user = ChannelUserService.getCurrentUserFromLocalStorage()

    const plans = useSelector(selector.channelPlans)

    const [plan, setPLan] = useState<ChannelPlanModel>({
        PlanId: "",
        PLanName: "",
        PriceId: "",
        Status: "" as ChannelPlanStatus,
        Price: 0,
        Features: [],
        FeatureKeys: [],
        Quantity: 1,
        AddOns: [],
        IsReccuring: false,
        IsMonthly: false,
        IsYearly: false,
        Created_At: "",
        Last_Updated_At: "",
        Start_Date: "",
        End_Date: ""
    })

    const [quantity, setQuantity] = useState<number>(plan.Quantity)
    const [show, setShow] = useState<boolean>(false)
    const params = new URLSearchParams(location.search);
    const dispatch = useDispatch();

    const success = params.get("success");
    const cancel = params.get("canceled");

    useEffect(() => {
        getPlanDetails();
        setHeaderTitle(pageTitles.PLANS)
        setRefreshHandler(getPlanDetails)
        if (!plans.length) {
            LoadChannelPlans(dispatch)
        }
    }, [])

    const handlePlans = () => {
        ChannelUserService.getStripeCustomerPortalession().then((res) => {
            window.location.href = res.data.url
        }).catch(() => {
        })
    }

    useEffect(() => {
        setQuantity(plan.Quantity)
    }, [plan])

    const getPlanDetails = () => {
        setLoadingPlan(true)
        ChannelUserService.getUserPlanDetails().then((res) => {
            setLoadingPlan(false)
            setPLan(mapToPlanModel(res.data))
            setHeaderCount(`${res.data.quantity} ${res.data.quantity === 1 ? "plan" : "plans"}`)
        }).catch(() => {

        })
    }

    const handlePlanQuantity = () => {
        setIsLoading(true)
        if (!plan.IsYearly && !plan.IsMonthly) {
            ChannelUserService.BuyPlan({ organization_id: user.OrganizationID, product_id: plans.filter((x) => x.Type === ValidityType.ONETIME)[0].ProductId, quantity: quantity - plan.Quantity, price_id: plan.PriceId, mode: "one_time" }).then(
                (res) => {
                    setIsLoading(false)
                    if (res.data.url) {
                        window.location.href = res.data.url
                    } else {
                        navigate(`${AppRoutes.CHANNELS_PLANS}?canceled=true`)
                    }

                }).catch(() => {
                    setIsLoading(false)
                    navigate(`${AppRoutes.CHANNELS_PLANS}?canceled=true`)
                })
        } else {
            ChannelUserService.ChangePlan({ quantity: quantity, price_id: plan.PriceId }).then((res) => {
                setIsLoading(false)
                window.location.href = res.data.url
            }).catch(() => {
                setIsLoading(false)
                navigate(`${AppRoutes.CHANNELS_PLANS}?canceled=true`)
            })
        }
    }

    const handleCancelSubscription = () => {
        ChannelUserService.cancelSubscription().then((res) => {
            window.location.href = res.data.url
        }).catch(() => {
            setToast("Failed to cancel subscription,please try again later", ToasterType.DANGER)
        })
    }

    useEffect(() => {
        if (success === "true") {
            setShow(true)
            setTimeout(() => {
                navigate(AppRoutes.CHANNELS_DASHBOARD)
            }, 1500);
        }
    }, [success])

    return (
        <div className={`w-p-100 h-p-100 d-flex justify-center align-center bg-color-secondary flex-direction`}>
            <div className="w-p-96 h-p-100 bg-color-side-bar br-3 d-flex justify-center align-center">
                <div className="w-p-98 h-p-96 bg-color-secondary br-3 o-y-scroll">
                    {changePlan ?
                        <ChannelSelectPlanComponent CurrentPlan={plan} handleChangePlan={() => { setChangePlan(false) }} />
                        :
                        loadingPlan
                            ?
                            <div className="w-p-90 br-4 mx-auto mt-4 o-x-hidden">
                                <AvatarLoaderComponent LoaderAnimation={PlanLoader} />
                            </div>
                            :
                            <>
                                <div className="w-p-90 br-4 border-primary-divider mx-auto mt-4 o-x-hidden">
                                    <div className="w-p-100 h-15 bg-color-primary-link d-flex">
                                        <div className="flex-1 h-p-100 d-flex flex-direction justify-center">
                                            <div className="pl-4 h1-semibold d-flex align-center color-secondary">
                                                <div>
                                                    {plan.PLanName} Plan
                                                </div>
                                                <div className="h-3 h4-medium px-2 ml-2 bg-color-channel-plan-status-box color-secondary br-3 d-flex align-center">
                                                    {plan.Status === ChannelPlanStatus.TRAIL ? "on trial" : plan.Status}
                                                </div>
                                            </div>
                                            <div className="pl-4 h4-regular d-flex align-center color-primary-text-field">
                                                Your current subscription plan
                                            </div>
                                        </div>
                                        <div className="h-p-100 ml-auto d-flex flex-direction justify-center">
                                            <div className="mr-4 sign-up-sucess-title d-flex align-end justify-center color-secondary">
                                                ${plan.Price / 100}
                                            </div>
                                            <div className="mr-4 h4-regular d-flex align-center justify-center color-primary-text-field">
                                                {plan.IsMonthly ? 'per month' : plan.IsYearly ? "per year" : "One Time Payment"}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="h-20 d-flex justify-around align-center px-2">
                                        <div className="w-p-30 h-p-60 bg-color-channel-template-background br-3 d-flex flex-direction justify-center">
                                            <div className="h5-medium color-text-field-font d-flex align-center ml-4">
                                                <div className="w-4 h-4 d-flex align-center justify-center mr-2 mb-1 br-2 bg-color-send-message-select-channel">
                                                    <DateTimePickerBlueIcon className="w-2 h-2" />
                                                </div> Next Billing Date
                                            </div>
                                            <div className="h3-semibold ml-4">
                                                {(!plan.IsMonthly && !plan.IsYearly) ? "Life Time" : plan.End_Date}
                                            </div>
                                        </div>
                                        <div className="w-p-30 h-p-60 bg-color-channel-template-background br-3 d-flex flex-direction justify-center">
                                            <div className="h5-medium color-text-field-font d-flex align-center ml-4">
                                                <div className="w-4 h-4 d-flex align-center justify-center mr-2 mb-1 br-2 bg-color-send-message-select-channel">
                                                    <UsersPrimaryDarkIcon className="w-2 h-2" />
                                                </div>
                                                <div> Quantity / Users </div>
                                            </div>
                                            <div className="h3-semibold ml-4">
                                                {plan.Quantity}
                                            </div>
                                        </div>
                                        <div className="w-p-30 h-p-60 bg-color-channel-template-background br-3 d-flex flex-direction justify-center pl-4">
                                            <div className="h5-medium color-text-field-font d-flex align-center">
                                                <div className="w-4 h-4 d-flex align-center justify-center mr-2 mb-1 br-2 bg-color-send-message-select-channel">
                                                    <CardBlueIcon className="w-2 h-2" />
                                                </div>Per User
                                            </div>
                                            <div className="h3-semibold">
                                                ${plan.Price / 100}/{plan.IsMonthly ? 'month' : plan.IsYearly ? "year" : "One Time Payment"}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-p-100 pl-4 h4-semibold mb-2">
                                        Plan Features
                                    </div>
                                    <Grid className="px-4" container>
                                        {plan.Features.map(x =>
                                            <Grid item md={6} className="h4-regular h-4 d-flex align-center">
                                                <PlanFeatureTickIcon className="mr-1" />
                                                {x}
                                            </Grid>
                                        )}
                                    </Grid>
                                    {(plan.IsMonthly || plan.IsYearly) && <>
                                        <div className="bb-primary-divider-1 h-2 mx-4"></div>
                                        <div className="mx-4 d-flex justify-center">
                                            <ButtonComponent ButtonLabel="Cancel Subscription" Variant="secondary-btn" OnClick={() => { handleCancelSubscription() }} ClassName=" h-5 mt-2 mb-4 mr-2 br-3 h4-medium mr-2 flex-1" />
                                            <ButtonComponent ButtonLabel="Change Plan" Variant="primary-btn" OnClick={() => { setChangePlan(true) }} ClassName="bg-color-primary-link h-5 mt-2 mb-4 br-3 h4-medium flex-1" />
                                        </div>
                                    </>
                                    }
                                </div>
                                <div className="w-p-90 br-4 border-primary-divider mx-auto my-4 o-hidden">
                                    <div className="d-flex h-5 mt-4 px-4 mb-4">
                                        <div className="flex-1 ">
                                            <div className="h3-semibold">
                                                Quantity / Users
                                            </div>
                                            <div className="h6-regular color-plans-secondary-text-color mt-1">
                                                Add or remove plan/team members from your plan
                                            </div>
                                        </div>
                                        <div className="w-5 h-5 d-flex justify-center align-center h3-medium b-around-text-field-border-4 br-1 c-pointer" onClick={() => { quantity !== 1 && setQuantity(quantity - 1) }}>
                                            −
                                        </div>
                                        <div className="w-5 h-5 mx-1 d-flex justify-center align-center h3-semibold">
                                            {quantity}
                                        </div>
                                        <div className="w-5 h-5 d-flex justify-center align-center h3-medium b-around-text-field-border-4 br-1 c-pointer" onClick={() => { setQuantity(quantity + 1) }}>
                                            ＋
                                        </div>
                                    </div>
                                    {plan.Quantity !== quantity &&
                                        <>
                                            <div className="mx-4 br-4 plan-trail-box mx-auto px-4 py-2 o-hidden">
                                                <div className="h4-medium d-flex align-center">
                                                    <DisclaimerBlueIcon className="mr-1" />
                                                    {quantity > plan.Quantity ? "Adding Plans" : "Reducing Plans"}
                                                </div>
                                                <div className="h6-regular color-plans-secondary-text-color mt-1">
                                                    {quantity > plan.Quantity ? `You'll be charged a prorated amount of ${(!plan.IsMonthly && !plan.IsYearly) ? ((plan.Price / 100) * (quantity - plan.Quantity))?.toFixed(2) : ((plan.Unused_Amount / plan.Quantity) * (quantity - plan.Quantity))?.toFixed(2)} for remaining days untill ${(!plan.IsMonthly && !plan.IsYearly) ? "Life Time" : plan.End_Date}` : `Takes effect at the end of the billing cycle ${plan.End_Date}`}
                                                </div>
                                            </div>
                                            <div className="mx-4 d-flex justify-center">
                                                <ButtonComponent Loading={isLoading} ButtonLabel={quantity > plan.Quantity ? "Add Plan" : "Reduce Plan"} Variant="primary-btn" OnClick={handlePlanQuantity} ClassName="bg-color-primary-link h-5 mt-2 mb-4 br-3 h4-medium w-p-100" />
                                            </div>
                                        </>
                                    }
                                </div>
                            </>
                    }
                    {show &&
                        <Dialog open={show} >
                            <DialogContent className="px-0">
                                <div className="d-flex flex-direction align-center">
                                    <div className="p-2 br-50"> <SuccessIcon /></div>
                                    <span className="h2-semibold my-1">
                                        Payment Successful!
                                    </span>
                                    <span className="h4-medium my-2 w-p-70 t-align-center color-plans-secondary-text-color">Your payment has been processed successfully. Redirecting to your dashboard...</span>
                                    <div className="w-p-70 my-4">
                                        <LinearProgress color="success" /></div>
                                </div>
                            </DialogContent>
                        </Dialog>
                    }

                    {
                        <Dialog open={cancel === "true"} >
                            <DialogContent className="px-0">
                                <div className="d-flex flex-direction align-center">
                                    <div className="p-2 br-50"><PaymentFailureIcon className="w-12 h-12" /></div>
                                    <span className="h2-semibold">
                                        Payment Failed
                                    </span>
                                    <span className="h4-medium w-p-70 t-align-center color-plans-secondary-text-color">There was an issue processing your payment. Please check your payment details and try again.</span>
                                    <ButtonComponent ButtonLabel={buttonLabels.TRY_AGAIN} Variant={"primary-btn"} OnClick={() => navigate(AppRoutes.CHANNELS_PLANS)} />
                                </div>
                            </DialogContent>
                        </Dialog>
                    }
                </div>
            </div >
        </div>
    )
}

export default ChannelPlans;